'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { DecodeImageQuality, getDecodeImage } from '@actr/utilities/src/url/decode-image';
import React, { memo } from 'react';

import config from '@/configs';
import { CountryToCityPopularRouteList } from '@/services/models/avia/country-to-city';

import * as Styled from './style.css';

const CountryToCityPopularDirections: React.FC<CountryToCityPopularRouteList> = props => {
  const { title, list } = props || {};

  const renderDesktopView = () => (
    <div
      className={Styled.DesktopCities}>
      {
        list!.map((o, i) => (
          <a
            className={Styled.City}
            key={i}
            href={`/${o.path}`}>
            <img
              className={Styled.CityImg}
              src={!o.city_img
                ? `${config.cmsMediaUrl}images/seo/empty-img.jpg`
                : getDecodeImage(o.city_img, DecodeImageQuality.Q30)}
              alt={o.name}
            />
            <Text font="title.m">
              { o.name }
            </Text>
          </a>
        ))
      }
    </div>
  );

  return (
    <ContentBlock className={Styled.ContentBlock} id="to_city_popular_routes">
      <Text tagName="h3" font="title.x2l">{title}</Text>
      { !!list && renderDesktopView() }
    </ContentBlock>
  );
};

export default memo(CountryToCityPopularDirections);
